import axios from "./axios";
import RestfulService from "api/common/RestfulService";
// TODO merge with esg-admin/organization-adminApi.js

export const organizationService = new RestfulService("/administration/organization");

const api = {
  getOrganizationId(subdomain) {
    return axios.get("/public/organizations", { params: { subdomain: subdomain } }).then(({ data }) => data);
  },

  getOrganizationSubDomain(organizationId) {
    return axios
      .get("/public/organizations/subdomain", { params: { org_id: organizationId } })
      .then(({ data }) => data);
  },

  getOrganizationUsers(accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };

    return axios.get("/users/organization-members", headers).then(({ data }) => data);
  },

  getSupplierUsers(supplierId, accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/users/suppliers/${supplierId}`, headers).then(({ data }) => data);
  },

  getOrganizationDivisions(accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get("/divisions", headers).then(({ data }) => data);
  },

  getAllSuppliers(accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get("/suppliers", headers).then(({ data }) => data);
  },

  getOrganizationStructure(accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get("/public/organizations/structure", headers).then(({ data }) => data);
  },

  // HACK: Global.organizationModules is set by AuthProvider by calling this function
  useGetOrganizationModules() {
    return axios.get("/public/organizations/modules").then(({ data }) => data);
  },

  getOrganizationAssociations(email) {
    return axios.get("/public/organizations/association", { params: { email: email } }).then(({ data }) => data);
  },

  getEmissionFactorMapping(accessToken) {
    const headers = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.get("/administration/organization/emission-factor/mapping", headers).then(({ data }) => data);
  },

  updateEmissionFactorMapping(mapping, accessToken) {
    const headers = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.put("/administration/organization/emission-factor/mapping", mapping, headers).then(({ data }) => data);
  },

  // ESG-3927: org Scope 2 engine config — { scopeTwoVersion, scopeTwoV1Periods }.
  getScopeTwoConfig(accessToken) {
    const headers = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.get("/administration/organization/scope-two-config", headers).then(({ data }) => data);
  },

  updateScopeTwoConfig(config, accessToken) {
    const headers = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.put("/administration/organization/scope-two-config", config, headers).then(({ data }) => data);
  },

  // ESG-4018: { startDay, startMonth, endDay, endMonth, overrides: [{ year, startDate, endDate }] }.
  // A PUT replaces the override list whole.
  getFinancialYear(accessToken) {
    const headers = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.get("/administration/organization/financial-year", headers).then(({ data }) => data);
  },

  updateFinancialYear(config, accessToken) {
    const headers = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.put("/administration/organization/financial-year", config, headers).then(({ data }) => data);
  },
};

export default api;
